<template>
    <div class="main-content events-list" v-cloak>
        <div class="container">
            <div class="events-group-header is-current">
                <div class="events-group-header-icon"><span>A</span></div>
                <div class="content">About</div>
            </div>
            <p>We help you plan all your friends and family events</p>
            <p>Manage your Events</p>
            <p>Keep track of your Events</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "support",
    components: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    mounted() {},
    created() {}
};
</script>
<style scoped>
p,
ul li {
    font-size: 1.2rem;
    line-height: 1.8rem;
}

ul {
    list-style-type: initial;
    margin-left: 14px;
}

ul li {
    margin-bottom: 0.4rem;
}

.container {
    margin-bottom: 4rem;
}

a {
    color: #00a8b3;
    word-break: break-word;
}

.events-group-header {
    margin-top: 3.2rem;
}

.events-group-item-header {
    margin-top: 2.4rem;
}

.events-group-header .content {
    flex: 1;
}
</style>
